<template>
  <v-app
    :dark="darkMode"
    v-if="fontFamily"
    id="inspire"
    class="background"
    :style="'--fontFamily: ' + fontFamily.value"
    height="60px"
  >
    <v-container class="pa-0" fluid>
      <!-- Header -->
      <v-layout
        class="fixed-header cursor-pointer"
        @click.stop="goToCompanyHome()"
        v-if="company.logo_url && company.custom_properties.use_logo_as_header_bg"
        row
        wrap
      >
        <v-flex xs12 class="px-3">
          <v-img width="100%" :src="company.logo_url" />
        </v-flex>
      </v-layout>

      <v-toolbar
        v-if="!hideHeader && !isEmbedMode"
        flat
        :height="!company.custom_properties.use_logo_as_header_bg ? 60 : 50"
        class="fixed-header background"
        justify-start
        :class="{'px-5': !isMobileView}"
      >
        <template v-if="company && !company.custom_properties.use_logo_as_header_bg">
          <v-layout v-if="company.logo_url" align-center justify-start class="ml-mobile" height="100%">
            <v-card
              width="124.95px"
              height="fill-height"
              center
              flat
              style="background: none"
            >
              <v-img
                v-if="company.logo_url"
                width="100%"
                height="100%"
                class="cursor-pointer mt-auto mr-2 align-center"
                contain
                :src="company.logo_url"
                @click.stop="goToCompanyHome()"
              ></v-img>
            </v-card>
          </v-layout>

          <div
            v-else
            class="primary--text title font-weight-bold cursor-pointer"
            @click.stop="goToCompanyHome()"
          >
            {{ company.title }}
          </div>
        </template>
        <v-spacer></v-spacer>
        <v-layout row align-center justify-end fill-height>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn
              :color="$route.path === '/' ? 'primary' : 'secondary'"
              flat
              class="mx-3 font-weight-bold"
              small
              @click="goToCompanyHome"
              :class="{ 'active-bottom-border': $route.path === '/' }"
              >{{ $t("screener.btn.home") }}</v-btn
            >
            <v-btn flat class="mx-3 font-weight-bold"
                active-class="active-bottom-border"
                small
                :to="{ name: 'company.festivals' }"
                v-if="!isNetfestVod"
              >
              {{ $t('company.header.menu.festivals') }}
            </v-btn >
            <v-btn
              v-if="company.active_pricing_plans_count"
              :color="$route.name === 'subscription.plans' ? 'primary' : 'secondary'"
              flat
              class="mx-3 font-weight-bold"
              active-class="active-bottom-border"
              small
              :to="{ name: 'subscription.plans' }"
              >{{ $t("company.header.menu.pricing") }}</v-btn
            >
            <v-btn
              v-if="company.active_vod_movies_count && !isNetfestVod"
              :color="$route.name === 'vod.movies' ? 'primary' : 'secondary'"
              flat
              class="mx-3 font-weight-bold"
              active-class="active-bottom-border"
              small
              :to="{ name: 'vod.movies' }"
              >{{ $t("screener.btn.vod_movies") }}</v-btn
            >
            <v-btn
              v-if="!isNetfestVod"
              :color="$route.name === 'program' ? 'primary' : 'secondary'"
              flat
              active-class="active-bottom-border"
              class="mx-3 font-weight-bold"
              small
              :to="{ name: 'program' }"
              >{{ $t("screener.header.btn.programs") }}</v-btn
            >
            <v-btn
              v-if="company.active_pricing_plans_count"
              :color="isPricingPageActive ? 'primary' : 'secondary'"
              flat
              class="mx-3 font-weight-bold"
              @click.stop="goToPricingPage()"
              >{{ $t("screener.btn.buy_ticket") }}</v-btn
            >
            <div :key="isLoggedIn" class="d-flex align-center">
            <v-btn
              v-if="isLoggedIn && profile"
              color="secondary"
              flat
              center
              class="mx-3 font-weight-bold"
              small
              @click.stop
            >
            <v-menu offset-y  open-on-hover left :nudge-left="0" :close-on-content-click="false" :close-delay="200" >
                <template v-slot:activator="{ on }" class="text-xs-center">
                  <v-layout column wrap align-center v-on="on">
                    <!-- <avatar class="cursor-pointer" :username="profile.email"></avatar> -->
                    <div class="cursor-pointer secondary--text d-flex align-center">
                      {{ $t("rms.toolbar.consumer.my_account.title") }}

                      <v-icon right size="24" color="secondary" class="ml-1"
                        >mdi-menu-down</v-icon
                      >
                    </div>
                  </v-layout>
                </template>

                <v-card>
                  <v-list>
                    <v-list-tile avatar>
                      <v-list-tile-avatar>
                        <avatar :size="42" :username="profile.email"></avatar>
                      </v-list-tile-avatar>

                      <v-list-tile-content>
                        <v-list-tile-title class="secondary--text">{{
                          profile.name ? profile.name : profile.email
                        }}</v-list-tile-title>
                        <v-list-tile-sub-title
                          class="Secondary--text"
                          v-if="profile.name"
                          >{{ profile.email }}</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>

                  <v-divider></v-divider>

                  <v-list>
                    <v-list-tile @click="goToDashboard({ tab: 'events' })">
                      <v-list-tile-action>
                        <v-icon color="primary"
                          >$vuetify.icons.rms_consumer_dashboard</v-icon
                        >
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title class="Secondary--text">{{
                          $t("rms.toolbar.consumer.header.menu.dashboard")
                        }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile
                      v-if="!isLoggedInWithLink && !isPreviewUser"
                      @click="goToDashboard({ tab: 'profile' })"
                    >
                      <v-list-tile-action>
                        <v-icon color="primary">mdi-account</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title class="Secondary--text">{{
                          $t("my_profile.title")
                        }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile @click="logout()">
                      <v-list-tile-action>
                        <v-icon color="primary">logout</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title class="Secondary--text">{{
                          $t("rms.toolbar.consumer.header.menu.logout")
                        }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-card>
              </v-menu>
            </v-btn>

            <v-btn v-else small color="secondary" class="mx-3 font-weight-bold" flat @click="goToLogin">{{
              $t("login.title")
            }}</v-btn>
            </div>
            <v-menu offset-y open-on-hover>
              <template v-slot:activator="{ on }">
                <v-btn text flat v-on="on" class="mx-0 px-0 secondary--text">
                  {{ currentLanguage }}
                  <v-icon right size="24" color="secondary" class="ml-0"
                    >mdi-menu-down</v-icon
                  >
                </v-btn>
              </template>
              <v-list>
                <div v-for="(item, index) in enabledLanguages" :key="index">
                  <v-list-tile @click="changeLocale(item.value)">
                    <v-list-tile-title
                      :class="[item.value == currentLanguage ? 'primary--text' : '']"
                      >{{ item.text }}</v-list-tile-title
                    >
                  </v-list-tile>
                  <v-divider></v-divider>
                </div>
              </v-list>
            </v-menu>
          </v-toolbar-items>
        </v-layout>
        <v-menu
          class="hidden-md-and-up"
          offset-y
          close-on-content-click
          close-on-click
          left
        >
          <v-toolbar-side-icon
            color="secondary--text"
            slot="activator"
            class="ml-3 align-center"
          ></v-toolbar-side-icon>
          <v-list v-if="isLoggedIn">
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <avatar :size="42" :username="profile.email"></avatar>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title class="primary--text">{{
                  profile.name ? profile.name : profile.email
                }}</v-list-tile-title>
                <v-list-tile-sub-title class="primary--text" v-if="profile.name">{{
                  profile.email
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>

          <v-divider></v-divider>
          <v-list>
            <template v-for="(menu, index) in menus">
              <v-list-tile
                v-if="menu.visible"
                :key="index + 1"
                @click="menu.action(menu.query)"
              >
                <v-list-tile-action>
                  <v-icon color="primary">{{ menu.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ menu.title }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
            <v-list-tile @click="changeLanguageDialog = true">
              <v-list-tile-action>
                <v-icon color="primary">mdi-translate</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  <change-language-dialog :enabled-languages="enabledLanguages"></change-language-dialog>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>

      <!-- Content -->
      <v-card v-if="isAppLoading" class="spinner-overlay background elevation-0">
        <spinner-loader ></spinner-loader>
      </v-card>

      <v-content class="px-3">
        <router-view class :key="$route.fullPath"></router-view>
      </v-content>
      <img
        height="1"
        width="1"
        style="display: none"
        v-if="showFbPixelImg"
        :src="
          'https://www.facebook.com/tr?id=' +
          company.fbpixelId +
          '&ev=PageView&noscript=1'
        "
      />
      <!-- Footer -->
    </v-container>
    <AppFooter v-if="!isEmbedMode" :isNetfestVod="isNetfestVod" :referrerUrl="referrerURl"></AppFooter>
  </v-app>
</template>
<script>
import DEFINES from "@/defines";
import Avatar from "vue-avatar";
import { mapState, mapGetters } from "vuex";
import i18n from "@/i18n";
import AppFooter from "../components/layout/company/Footer";
import { firebaseDatabase } from "@/mixins/firebase-database.js";
import ChangeLanguageDialog from "../components/dialogBox/ChangeLanguageDialog.vue";
import SpinnerLoader from "../components/SpinnerLoader.vue";
export default {
  name: "GuestLayout",
  data() {
    return {
      showFbPixelImg: false,
    };
  },
  metaInfo() {
    if (this.company) {
      return {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: "Home",
        // all titles will be injected into this template
        titleTemplate: this.company.title + " | %s",
        link: [{ rel: "icon", href: this.company.favicon_url }],
        meta: [
          {
            vmid: "description",
            name: "description",
            content: this.company.notes ? this.company.notes : this.company.title,
          },
          {
            property: "og:title",
            content: this.company.title,
            // following template options are identical
            // template: '%s - My page',
            template: (chunk) => `${chunk} | Home`,
            vmid: "og:title",
          },
          {
            property: "og:description",
            content: this.company.notes ? this.company.notes : this.company.title,
            vmid: "og:description",
          },
          {
            property: "og:url",
            content: this.company.domain,
            vmid: "og:url",
          },
          {
            property: "og:type",
            content: "website",
            vmid: "og:type",
          },
          {
            property: "og:site_name",
            content: this.company.title + " | home",
            vmid: "og:site_name",
          },
          {
            property: "og:image",
            content: this.company.logo_url,
            vmid: "og:image",
          },
          {
            property: "og:image:width",
            content: 400,
            vmid: "og:image:width",
          },
          {
            property: "og:image:height",
            content: 400,
            vmid: "og:image:height",
          },
        ],
      };
    }
  },
  components: {
    AppFooter,
    Avatar,
    ChangeLanguageDialog,
    SpinnerLoader
  },
  async beforeRouteEnter(to, from, next) {
    await next((vm) => {
      // if (to.params.screener_id) {
      //   vm.initializeCompany();
      // }
    });
  },
  mixins: [firebaseDatabase],
  computed: {
    ...mapState({
      company: (state) => state.company.company,
      is_rtl: (state) => state.app.app.is_rtl,
      colors: (state) => state.app.app.colors,
      profile: (state) => state.consumer.profile,
      isAppLoading: (state) => state.app.app.isAppLoading,
      referrerUrl: (state) => state.app.referrerURL,
    }),

    ...mapGetters("app", {
      isLoggedIn: "isLoggedIn",
      isNetfestVod: "isNetfestVod"
    }),
    ...mapGetters("company", {
      currentCompanyID: "getNavigationParamOfCompany",
    }),
    ...mapGetters("app", {
      isEmbedMode: "isEmbedMode",
      darkMode: "darkMode",
      fontFamily: "fontFamily",
      currentLanguage: "getCurrentLanguage",
    }),
    ...mapGetters("auth", {
      isLoggedInWithLink: "isLoggedInWithLink",
      isPreviewUser: "isPreviewMode",
      currentSession: "getSession",
    }),
    hideHeader() {
      return (
        this.company.id == DEFINES.FIREPLACE_AD_COMPANY_ID &&
        this.$route.params.screener_id == DEFINES.FIREPLACE_AD_SCREENER_ID
      );
    },
    menus() {
      return [
        {
          icon: "mdi-view-dashboard",
          title: i18n.t("rms.toolbar.consumer.header.menu.dashboard"),
          action: this.goToDashboard,
          query: { tab: "events" },
          visible: this.isLoggedIn,
        },
        {
          icon: "mdi-account",
          title: i18n.t("my_profile.title"),
          action: this.goToDashboard,
          query: { tab: "profile" },
          visible: this.isLoggedIn && !this.isLoggedInWithLink && !this.isPreviewUser,
        },
        {
          icon: "mdi-cards-outline",
          title: i18n.t("screener.btn.buy_ticket"),
          action: this.goToPricingPage,
          visible: this.company.active_pricing_plans_count,
        },
        {
          icon: "mdi-calendar-multiple",
          title: i18n.t("screener.header.btn.programs"),
          action: this.goToProgramsPage,
          visible: !this.isNetfestVod,
        },
        {
          icon: "mdi-cards-outline",
          title: i18n.t("screener.btn.vod_movies"),
          action: this.goToVodMoviesPage,
          visible: this.company.active_vod_movies_count && !this.isNetfestVod,
        },
        {
          icon: "logout",
          title: i18n.t("rms.toolbar.consumer.header.menu.logout"),
          action: this.logout,
          visible: this.isLoggedIn,
        },
        {
          icon: "login",
          title: i18n.t("login.title"),
          action: this.goToLogin,
          visible: !this.isLoggedIn,
        },
      ];
    },
    enabledLanguages() {
        if (this.company) {
            return ('enabled_language_support' in this.company.custom_properties) ? this.company.custom_properties.enabled_language_support : DEFINES.LOCALES; 
        }else{
            return DEFINES.LOCALES
        }
    }
  },
  mounted() {
    //Preview user can have multiple session
    if (this.isLoggedIn && !this.isPreviewUser) {
      this.bindSessionWithFBase(this.profile.id, this.currentSession.key);
    }
    this.loadFacebookPixel();
    // this._setRTL();
    // this._setThemeColors();
    this.getConsumerScreenings();
    this.getConsumerSubscription();
    this.loadFonts();
  },
  watch: {
    fontFamily: {
      deep: true,
      handler: function () {
        this.loadFonts();
      },
    },
  },
  methods: {
    loadFacebookPixel() {
      // if pixel ID is not avaialble
      if (
        this.company.custom_properties.fbpixelId == undefined ||
        this.company.custom_properties.fbpixelId == null
      ) {
        return;
      }
      var pixelId = this.company.custom_properties.fbpixelId;
      let script = document.createElement("script");
      script.text =
        "!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '" +
        pixelId +
        "');fbq('track', 'PageView');";
      document.head.appendChild(script);
      this.showFbPixelImg = true;
    },

    loadFonts() {
      var _this = this;
      var junction_font = new FontFace(
        this.fontFamily.value,
        `url(${this.fontFamily.url})`
      );
      junction_font
        .load()
        .then(function (loaded_face) {
          document.fonts.add(loaded_face);
          document.body.style.fontFamily = _this.fontFamily.value;
        })
        .catch(function (error) {});
    },

    _setThemeColors() {
      if (this.colors) {
        this.$vuetify.theme.primary = this.colors.primaryColor;
        this.$vuetify.theme.secondary = this.colors.secondaryColor;
        this.$vuetify.theme.background = this.colors.backgroundColor;
      }
    },
    _setRTL() {
      this.$vuetify.rtl = this.is_rtl;
    },

    goToDashboard(query = {}) {
      this.$router.push({ name: "user.dashboard", query: query }).catch((err) => {});
    },
    goToCompanyHome() {
      //in case of user redirected from netfest vod company and isnetfestvod is true
      if (this.isNetfestVod) {
        return window.open(this.referrerUrl);
      }

      this.$router
        .push({
          name: "company.dashboard",
        })
        .catch((err) => {});
    },
    goToLogin() {
      this.$router.push({
        name: "company.login",
      });
    },
    goToProgramsPage() {
      this.$router
        .push({
          name: "program",
        })
        .catch((err) => {});
    },

    logout() {
      try {
        // Logouts & redirects to company home already
        this.$store.dispatch("auth/logout", {});
        this.$store.dispatch("app/showAlert", {
          message: this.$t("logout/successfully"),
          color: "success",
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },

    initializeCompany() {
      try {
        this.$store.dispatch("company/initializeCompany");
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    async getConsumerScreenings() {
      if (!this.isLoggedIn) {
        return;
      }
      try {
        /* Getting it on layout mount so that any refund made reflects */
        await this.$store.dispatch("consumer/listScreenings", {
          company_id: this.company && this.company.id,
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    async getConsumerSubscription() {
      if (!this.isLoggedIn) {
        return;
      }
      try {
        /* Getting it on layout mount so that any refund made reflects */
        await this.$store.dispatch("subscription/get", {
          company_id: this.company && this.company.id,
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    goToPricingPage() {
      this.$router
        .push({
          name: "pricing.index",
        })
        .catch((err) => {});
    },
    goToVodMoviesPage() {
      this.$router
        .push({
          name: "vod.movies",
        })
        .catch((err) => {});
    },
    async changeLocale(value) {
      await this.$store.dispatch("app/updateLocale", {
        locale: value,
      });
    },
  },
};
</script>
<style>
#inspire {
  font-family: var(--FontFamily) !important;
}
#inspire .display-1,
#inspire .display-2,
#inspire .display-3,
#inspire .display-4,
#inspire .headline,
#inspire .title,
#inspire .subheading,
#inspire .body-2,
#inspire .body-1,
#inspire .caption {
  font-family: var(--FontFamily) !important;
}
.layout-container {
  max-width: 100vw !important;
}
.active-bottom-border {
  border-bottom: 2px #ffffff solid;
  font-weight: bold;
}

.v-btn--active:before,
.v-btn:hover:before,
.v-btn:focus:before {
  background-color: inherit;
}

@media only screen and (max-width: 768px) {
  .v-toolbar.background {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

@media only screen and (min-width: 769px) {
  .ml-mobile {
    margin-left: 7px !important;
    padding: 0px 8px 0px 0px;
  }
}

.spinner-overlay {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.spinner {
  position: relative;
  z-index: 2000 !important;
  width: 80px !important;
  height: 80px !important;
}

.spin-animation {
  animation: spin 1.5s linear infinite;
  width: 80px !important;
  height: 80px !important;
  background: transparent !important;
  transform-origin: center center;
}

.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

body {
  padding-top: 0px  !important; 
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media only screen and (min-width: 960px) {
  .container {
      max-width: 100%;
  }
}
html, body, #app {
  background-color: var(--v-background-base) !important;
  overflow-x: hidden;
  touch-action: manipulation;
}

.v-application {
  background-color: var(--v-background-base) !important;
}
</style>
